module.exports = __webpack_public_path__ + "static/img/yaoqing.d33f8c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/yaoqing.png
// module id = Ar7y
// module chunks = 24